import { collection, getDocs, query, where } from 'firebase/firestore';
import {
  firebaseAuth,
  firebaseFire as Libfirebase,
  firebaseStorage
} from '../helpers/firebase-config.js';
import { firebaseDb } from '../helpers/firebase-config2.js';
//o arquivo firebase-config esta dentro da pasta helpers;

export function setEspecialidade(data) {
  return new Promise(function (resolve, reject) {
    Libfirebase
      .collection('especialidades')
      .add(data)
      .then(() => resolve(true))
      .catch(error => {
        const erro = {
          error,
          msg:
            'Houve um problema ao cadastrar a especialidade, favor tentar novamente'
        };
        reject(erro);
      });
  });
}

export function getEspecialidade() {
  return new Promise(function (resolve, reject) {
    Libfirebase
      .collection('especialidades')
      .where('Ativo', '==', true)
      .get()
      .then(snap => {
        let ListEspecialidades = [];
        snap.forEach(doc => {
          const data = {
            ref: doc.ref,
            id: doc.id,
            especialidade: doc.data()
          };
          ListEspecialidades.push(data);
        });

        resolve(ListEspecialidades);
      })
      .catch(erro => {
        const error = {
          erro,
          msg:
            'Houve um erro ao retornar a lista de especialidades, favor tentar novamnete mais tarde'
        };
        reject(erro);
      });
  });
}

export function getEspecialidadeNew() {
  return new Promise(function (resolve, reject) {

    const q = query(
      collection(firebaseDb, "especialidades"),
      where("Ativo", "==", true)
    );
    // console.log("get espes")
    getDocs(q)
      .then(snap => {
        // console.log("get espes")
        let ListEspecialidades = [];
        snap.forEach(doc => {
          const data = {
            ref: doc.ref,
            id: doc.id,
            especialidade: doc.data()
          };
          ListEspecialidades.push(data);
        });

        resolve(ListEspecialidades);
      })
      .catch(erro => {
        const error = {
          erro,
          msg:
            'Houve um erro ao retornar a lista de especialidades, favor tentar novamnete mais tarde'
        };
        reject(erro);
      });
  });
}

export function updateEspecialidade(id, data) {
  return new Promise(function (resolve, reject) {
    Libfirebase
      .collection('especialidades')
      .doc(id)
      .update(data)
      .then(() => resolve(true))
      .catch(error => {
        const erro = {
          error,
          msg: error.code
        };
        reject(erro);
      });
  });
}
